import React from "react";
import PropTypes from "prop-types";

const NoDataMessage = ({ message }) => (
  <div data-testid="no-data-message">{message}</div>
);

NoDataMessage.displayName = "NoDataMessage";

NoDataMessage.propTypes = {
  message: PropTypes.string,
};

NoDataMessage.defaultProps = {
  message: "We're sorry! An error occurred. Please try again.",
};
export default NoDataMessage;
